<script>
  //	import { MasonryInfiniteGrid } from "@egjs/svelte-infinitegrid";
  import { onMount } from "svelte";
  import Masonry from "./components/Masonry.svelte";
  import Review from "./components/Review.svelte";
  import InfiniteLoading from "svelte-infinite-loading";

  let a = "b";
  let reviews = [];
  let page = 1;
  const url = `https://api.genu.io/customer-reviews?_sort=id:DESC`;

  onMount(async () => {
    //infiniteHandler();
  });
  async function infiniteHandler({ detail: { loaded, complete } }) {
    const start = 0 + (page - 1) * 12;
    const fetch_from = `${url}&_start=${start}&_limit=12`;
    const res = await fetch(fetch_from);
    if (res.ok) {
      reviews = [...reviews, ...(await res.json())];
      page++;
      loaded();
      //console.log('reviews: ', reviews);
      //console.log('page: ', page);
    } else {
      complete();
    }
  }
</script>

<main>
  <div class="_w-allreviews-top">
    <div class="_w-allrev-top-section">
      <div class="_w-allrev-title">
        <h1 class="_w-allrev-page-title">all Reviews</h1>
        <div class="_w-allrev-page-subtxt">고객님의 실시간 리뷰</div>
      </div>
      <a href="/my-page/reviews/" class="_w-allrev-write-button w-inline-block">
        <div>리뷰쓰기</div>
      </a>
    </div>
  </div>
  <div class="flex items-center justify-center">
    <div class="items-center w-full md:w-4/5 md:w-[80%]" id="review-contents">
      <Masonry
        stretchFirst={false}
        gridGap={"0.9em"}
        colWidth={"minmax(Min(24em, 100%), 1fr)"}
        items={reviews}
      >
        {#each reviews as review, i}
          <Review {review} order={i} />
        {/each}
      </Masonry>
    </div>
  </div>
</main>
<br />
<InfiniteLoading distance="120" on:infinite={infiniteHandler} />

<style global lang="postcss">
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  /* if mobile: full width, if desktop: 80% width */
  @media (min-width: 768px) {
    #review-contents {
      width: 80%;
      justify-content: center;
    }
  }

  .mcontainer {
    width: 80%;
    justify-content: center;
  }
  ._w-allrev-page-title {
    text-transform: uppercase;
    font-size: 38px;
  }
</style>
